import { SmartHomeConfig } from '../models';

const config: SmartHomeConfig = require(globals.NODE_ENV === 'production' ? './prod' : './dev').default;

export default config;



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/config/index.ts